<template>
  <div class="project-service-report" v-if="project">
    <b-row>
      <b-col lg="8" md="8" sm="12">
        <legend>
          <strong>{{ $t('serviceReport') }}: {{ $t('generate_report') }}</strong>
        </legend>
        <b-row>
          <b-col lg="4" md="7" sm="7">
            <AttachmentList
              :attachments="project.serviceReportAttachments"
              :attachmentType="attachmentType"
              v-on:attachment-list:delete="onDeleteAttachment"
            ></AttachmentList>
          </b-col>
          <b-col lg="8" md="5" sm="5">
            <router-link
              class="btn btn-success pull-right ml-2"
              :to="{
                name: 'ServicePrintPage',
                params: { projectNumber: project.number },
              }"
              target="_blank"
            >
              <i class="fa fa-file mr-2"></i>{{ $t('preview') }}
            </router-link>
            <ButtonWait
              v-if="!isGuest"
              :startCallback="startReportBuild"
              :pollCallback="fetchBuildState"
              class="pull-right"
            >
              <template v-slot:buttonText>
                {{ $t('generate_report') }}
              </template>
            </ButtonWait>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="4" md="4" sm="12" v-if="showToGuest('downloads', guestVisibleSections)">
        <legend>
          <strong>{{ $t('downloads') }}</strong>
        </legend>
        <b-row>
          <b-col lg="10" md="10" sm="10">
            {{ $t('serviceReportImageAttachments') }}
          </b-col>
          <b-col lg="2" md="2" sm="2">
            <ZipDownload
              attachmentType="serviceReportImageAttachments"
              :attachments="project.serviceReportImageAttachmentsZip"
              :project="project"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col lg="12" md="12" sm="12">
        <legend>
          <strong>{{ $t('serviceReport') }}: {{ $t('verification') }}</strong>
        </legend>
        <div class="verification-flex m-1">
          <VerificationState :project="project" verificationStateType="serviceVerificationState" />
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col lg="12" md="12" sm="12">
        <legend>
          <strong>{{ $t('serviceReport') }}: {{ $t('approvement') }}</strong>
        </legend>
        <div class="verification-flex m-1">
          <VerificationState
            :project="project"
            verificationStateType="serviceApprovementVerificationState"
          />
          <Card>
            <template #title>{{ $t('serviceApprovementNote') }} </template>
            <template #content>
              <b-form-textarea
                id="description"
                v-model="project.serviceApprovementNote"
                placeholder="..."
                rows="4"
                max-rows="4"
              ></b-form-textarea>
            </template>
          </Card>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-4" v-if="showToGuest('serviceReport', guestVisibleSections)">
      <b-col lg="12" md="12" sm="12">
        <legend>
          <strong>{{ $t('serviceReport') }}: {{ $t('collected_data') }}</strong>
        </legend>
        <MobileProjectsServiceReport :project="project" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ZipDownload from '@/components/ZipDownload';
import ButtonWait from '@/components/ButtonWait.vue';
import AttachmentList from '@/components/AttachmentList';
import MobileProjectsServiceReport from './MobileProjectsServiceReport.vue';
import VerificationState from '@/components/VerificationState.vue';
import Card from 'primevue/card';
import { canWriteField, showToGuest } from '@/helpers/userCapabilities';

export default {
  components: {
    ButtonWait,
    AttachmentList,
    MobileProjectsServiceReport,
    ZipDownload,
    VerificationState,
    Card,
  },
  props: {
    project: { type: Object },
  },
  data() {
    return {
      attachmentType: 'serviceReportAttachments',
      guestVisibleSections: {
        serviceReport: true,
      },
    };
  },
  computed: {
    ...mapGetters('auth', ['isGuest']),
  },
  methods: {
    ...mapActions(['buildServiceReport', 'fetchServiceReportAttachmentsBuildState']),
    /**
     * Start pdf build on server
     * Is provided to ButtonWait as callback function
     */
    async startReportBuild() {
      if (this.project) {
        await this.buildServiceReport(this.project.id);
      }
    },
    /**
     * Fetch build state from server (get's called once per second)
     * Is provided to ButtonWait as callback function
     */
    fetchBuildState() {
      this.fetchServiceReportAttachmentsBuildState(this.project.number);
      return this.project.serviceReportAttachmentsBuildState;
    },
    /**
     * Bubble up AttachmentList delete event
     */
    onDeleteAttachment(event) {
      this.$emit('project-report-attachment-list:delete', {
        attachmentId: event.attachmentId,
        attachmentType: this.attachmentType,
      });
    },
    canWriteField,
    showToGuest,
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.verification-flex {
  display: flex;
  gap: 1em;
  flex-flow: row wrap;
  flex-basis: 100%;
  justify-content: flex-start;
}

.verification-flex > div {
  flex: 1;
  min-width: 300px;
}
</style>
